module.exports = __webpack_public_path__ + "soc-link2ss.png?28aecb72f7a6b4ab583ccedb7522606b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc-link2ss.png
// module id = 78
// module chunks = 0